/* eslint-disable react/jsx-fragments */
import React from 'react';
import logoMobileDefaultUrl from '../../assets/images/logo/logo-light.svg';
import logoDesktopThemeDarkUrl from '../../assets/images/logo/logo-dark.svg';
import { RImage } from '../RImage';

const desktopThemeMap = {
  light: logoDesktopThemeDarkUrl,
  dark: logoDesktopThemeDarkUrl,
  default: logoDesktopThemeDarkUrl,
};

const mobileThemeMap = {
  default: logoMobileDefaultUrl,
};

export default function Logo({ theme }) {
  const logoDesktopSrc = desktopThemeMap[(theme && theme.title) || 'default'];
  const logoMobileSrc = mobileThemeMap[(theme && theme.title) || 'default'];

  return (
    <React.Fragment>
      <div className="logo">
        <RImage
          src={logoDesktopSrc}
          alt="Tensai Analyze"
          srcSet={[
            { src: logoDesktopSrc, screen: 'w1440' },
            { src: logoMobileSrc, screen: 'w480' },
          ]}
        />
      </div>
    </React.Fragment>
  );
}
